import './Theme.Wrapper.Paper.scss';
export default 'ThemeWrapperPaper';
